import { Component, OnInit, ViewChild } from '@angular/core';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from '../../login/login.service';
import { CaseService } from '../../cases/_types/case-service';
import { DialogService } from 'primeng/dynamicdialog';
import { CaseServiceDetailComponent } from '../../cases/cases-detail/service/case-service-detail/case-service-detail.component';
import { ChatService } from '../../chat/_services/chat.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { AndFilter, Filter, FilterOperation, NotFilter, OrFilter } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom, timeout } from 'rxjs';
import { CasesServicesService } from '../../cases/_services/cases-services.service';
import { DatePipe } from '@angular/common';
import { User } from '../../users/_types/user';
import { LocalStorageService } from 'angular-web-storage';
import { Case } from '../../cases/_types/case';
import { CasesService } from '../../cases/_services/cases.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TasksService } from '../../tasks/_services/tasks.service';
import moment from 'moment';
import { CasesStatesService } from '../../cases/_services/cases-states.service';
import { CasesDetailGeneralComponent } from '../../cases/cases-detail/general/general.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CasesLogsService } from '../../cases/_services/cases-logs.service';
import { CaseLog, CaseLogResourceType } from '../../cases/_types/case-log';
import { MailMessageService } from '../../comunications/_services/mail-messages.service';
import { MailMessageRecipientService } from '../../comunications/_services/mail-messages-recipients.service';
import { CdrService } from '../../phone/_services/cdr.service';
import { Cdr } from '../../phone/_types/cdr';
import { RecordingService } from '../../phone/_services/recording.service';
import { Recording } from '../../phone/_types/recording';
import { FilesService } from '../../common/_services/files.service';
import { MailMessage } from '../../comunications/_types/mail-message';
import { TransactionsTypesService } from '../../transactions/_services/transactions-types.service';
import { TransactionsStatesService } from '../../transactions/_services/transactions-states.service';
import { TransactionsService } from '../../transactions/_services/transactions.service';
import { UsersService } from '../../users/_services/users.service';
import { DashboardService } from '../_services/dashboard.service';
import { ContractProcessor } from '../../companies/_types/contract-processor';
import { ContractProcessorsService } from '../../companies/_services/contracts-processors.service';
import { WhatsAppChatComponent } from '../../whatsapp/chat/whatsapp-chat.component';
import { PhoneService } from '../../phone/_services/phone.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ComunicationsComponent } from '../../comunications/communications/comunications.component';
import { CompaniesService } from '../../companies/_services/companies.service';
import { ContractsService } from '../../companies/_services/contracts.service';
import { CaseLogTypesService } from '../../cases/_services/cases-log-types.service';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

  public loadingServices: boolean = false;
  public caseServices: CaseService[] = [];
 // public caseServicesNoCompany: Case[] = [];
  public totalServicesRecords: number = 0;
  public totalServicesNoCompanyRecords: number = 0;
  public totalInvoicesDueSoon: number = 0;
  public totalServicesNoProcessorRecords: number = 0;
  public totalServicesActiveRecords: number = 0;
  public totalServicesWorkInProgressRecords: number = 0;
  public totalServicesReviewTodayRecords: number = 0;
  public totalServicesReviewOldRecords: number = 0;
  public totalServicesNoCasesServices: number = 0;
  
  public allowWriteService: boolean = false;
  public allowDeleteService: boolean = false;
  public user!:User;
  public totalTask: number = 0;
  public processors: User[] = [];
  public startOfDay: Date = moment().startOf('day').toDate();
  public endOfDay: Date = moment().endOf('day').toDate();

  public globalFilters: any = {
    processorId: null
  };

  public processorContracts: ContractProcessor[] = [];
  public processorContractIds: string[] = [];

  public casesIsInitial: Case[] = [];
  public totalcasesIsInitial: number = 0;
  //ids de los estados iniciales (TRAMITATION_PENDING, PRE_CASE_SERVICE, ASSIGNMENT_PENDING) resueltos una vez,
  //para filtrar por caseStateId (indexado) en vez de por caseState.code (une cases_states y no usa el índice).
  public initialCaseStateIds: string[] = [];
  public loading: boolean = false;
  private lastGridEvent: any;
  private lastGridCasesIsInitial: any;
  public filters: any = {
    caseNumber: new Filter(FilterOperation.contains, 'caseNumber')
  };
  public caseStateId: string="";
  public lastGridLogEvent: any;
  public loadingLogs: boolean = false;
  public totalLogsRecords: number = 0;
  public caseLogs: any[] = [];
  public resourceCaseLog: { [key: string]: any } = [];
  public caseLogResourceType: any[] = [
      {name: 'Llamada', id: CaseLogResourceType.Call},
      {name: 'Correo', id: CaseLogResourceType.Mail},
      {name: 'Chat', id: CaseLogResourceType.Chat},
      {name: 'SMS', id: CaseLogResourceType.SMS},
    ];
  public selectedCase?: Case;
  private VIEW_CONTRACTS_CASES: boolean = this.loginService.hasPermission("CASES.VIEW_CONTRACTS_CASES");
  private VIEW_ALL_CASES: boolean = this.loginService.hasPermission("CASES.VIEW_ALL_CASES");

  public loadProcessorContractsCalled: boolean = false;

   //panel de opciones de telefono
  @ViewChild('phoneOverlayPanel') public phoneOverlayPanel?:OverlayPanel;
  public phoneOverlayPanelData:any = {
    phoneNumber: null,
    callerId: null
  };

  public caseLogsFilter: any = {
    caseLogTypeId: null,
    caseContractId: null,
    caseCompanyId: null,
  };
  
  public companies: any[] = [];
  public contracts: any[] = [];
  public caseLogTypes: any[] = [];

  public allowAssignProcessor: boolean = false;
  public displayProcessorModal: boolean = false;
  public selectedCases: any[] = [];
  public selectedCases1: any[] = [];
  public selectedCases2: any[] = [];
  public selectedCaseIds: any[] = []; //Los ids seleccionados
  public processorId: string = "";

  public allowRecordingAccess: boolean = false;

  constructor(
    private topbarService: TopbarService,
    private dialogService: DialogService,
    public loginService: LoginService,
    private chatService: ChatService,
    private storage: LocalStorageService,
    private casesServicesService: CasesServicesService,
    private casesServices: CasesService,
    private router: Router,
    private tasksService: TasksService,
    private casesStatesService: CasesStatesService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private casesLogsService: CasesLogsService,
    private mailMessageService: MailMessageService,
    private mailMessageRecipientService: MailMessageRecipientService,
    private cdrService:CdrService,
    private recordingService:RecordingService,
    private filesService: FilesService,
    private transactionsTypesService: TransactionsTypesService,
    private transactionsStatesService: TransactionsStatesService,
    private transactionsService: TransactionsService,
    private usersService: UsersService,
    private dashboardService: DashboardService,
    private contractProcessorsService:ContractProcessorsService,
    private phoneService: PhoneService,
    private companiesService: CompaniesService,
    private contractsService: ContractsService,
    private caseLogTypeService: CaseLogTypesService,
    private route: ActivatedRoute
  ) {
  }

  async ngOnInit(): Promise<void> {
    

    this.topbarService.setTitle("Dashboard");
    this.user = this.storage.get('user');
    this.allowRecordingAccess = this.loginService.hasPermission("CASES.ACCESS_RECORDINGS");

    await this.loadProcessorContracts();


    this.loadInitialState();
   // this.loadServices({first: 0, rows:20});
    //this.loadLogs({first: 0, rows:25});
    this.loadInvoicesDueSoon();
    this.loadPendingTasks();    
    //this.loadDataCasesIsInitial({first: 0, rows:10});
    this.loadProcessors();
    this.loadFullInfo();

    //para filtros de la tabla de logs.
    this.loadCaseLogTypes();
    this.loadCompanies();

    this.allowWriteService = this.loginService.hasPermission("CASES.WRITE");
    this.allowDeleteService = this.loginService.hasPermission("CASES.DELETE");
    this.allowAssignProcessor =  this.loginService.hasPermission("CASES.ASSIGN_PROCESSOR");
    
    //Que vaya directamente a la sección que llega por ruta... 
    this.route.paramMap.subscribe((params: ParamMap) => {
      var link = params.get('link') ?? '';
      if(link!=""){
        setTimeout(() => {
          this.waitingForLoadingElements(link)
        }, 500);
      }
    });
  }

  async applyGlobalFilters(){
    //this.loadCasesReviewToday();
    //this.loadCasesReviewOld();
    this.loadServices(this.lastGridEvent);
    this.loadLogs(this.lastGridLogEvent);
    this.loadDataCasesIsInitial(this.lastGridCasesIsInitial);
    
    this.loadFullInfo();
  }

  async loadProcessors() {

    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 }
    }
    let filters: any = {
      userType: new Filter(FilterOperation.contains, 'userType.code', '', 'processor')
    };
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.usersService.all(params));
    this.processors = response.data;
  }

  async loadProcessorContracts(){
    
    let filter: any = {
      processorId: new Filter(FilterOperation.equals, 'processorId', '', this.user.id)
    };
    let params:IParamsCollection = {
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.contractProcessorsService.all(params));
    this.processorContracts = response.data;
    this.processorContractIds = this.processorContracts.map(pc => pc.contractId);
    this.loadProcessorContractsCalled = true;
  }

  async loadServices($event: any) {
    this.lastGridEvent = $event;
    this.loadingServices = true;
    let params: IParamsCollection = {
      sort: ['date'],
      page: { number: $event.first + 1, size: $event.rows },
      include:['worker','case.client', 'case.processor', 'case.contract', 'materials.material'],
      fields: {
        cases: 'id,caseNumber,reference,processorId,processor,clientId,client,contractId,contract,caseDate',
        users: 'id,name,absence',
        clients: 'id,name,phone1,phone2,email',
        workers: 'id,name,phone1,phone2,email',
        contracts: 'id,code,name',
        caseServiceMaterials: 'materialId,material',
        materials: 'name,iconClass'
      }
    }
    if ($event.sortField) {
      params.sort = [($event.sortOrder > 0 ? '' : '-') + $event.sortField];
    }
    let filters: any = {
      dateEnd: new NotFilter(FilterOperation.equals, "dateEnd",'',null,true),
      isCancelled: new Filter(FilterOperation.equals, "isCancelled",'',false),
      isValidated: new Filter(FilterOperation.equals, "isValidated",'',false)
    };
    
    //Si tengo permiso de ver todos, ve todos, si es el permiso de 
    if(!this.VIEW_ALL_CASES){
      
      if(this.VIEW_CONTRACTS_CASES){

        //o es mia, o es una ausencia o son responsable del contrato o no tiene tramitador pero está en mis contratos.
        
        filters['processorId'] = new OrFilter([
          new Filter(FilterOperation.equals, 'case.contract.responsibleUserId', '', this.user.id),
          new Filter(FilterOperation.equals, 'case.contract.secondResponsibleUserId', '', this.user.id),
          new Filter(FilterOperation.equals, 'case.processorId', '', this.user.id),
          //new Filter(FilterOperation.equals, 'case.processor.absence', '', true),
          new AndFilter([
            new Filter(FilterOperation.equals, 'case.processorId', '', null, true), 
            new Filter(FilterOperation.equals, 'case.contract.responsibleUserId', '', this.user.id)]),
          new AndFilter([
            new Filter(FilterOperation.equals, 'case.processor.absence', '', true),
            new Filter(FilterOperation.any, 'case.contractId', '', (this.processorContractIds.length>0?this.processorContractIds:null))
          ])
        ]);

      }else{
        filters['processorId'] =new OrFilter([
          new Filter(FilterOperation.equals, 'case.processorId', '', this.user.id),
          new AndFilter([
            new Filter(FilterOperation.equals, 'case.processorId', '', null, true), 
            new Filter(FilterOperation.any, 'case.contractId', '',(this.processorContractIds.length>0?this.processorContractIds:null))]), //esta en mis contratos pero no tiene tramitador.
          new AndFilter([
            new Filter(FilterOperation.equals, 'case.processor.absence', '', true),
            new Filter(FilterOperation.any, 'case.contractId', '', (this.processorContractIds.length>0?this.processorContractIds:null))
          ])
      ]);
      }
    }

    //si hay un tramitador forzado, solo ese tramitador
    if(this.globalFilters.processorId) filters['processorId'] = new Filter(FilterOperation.equals, 'case.processorId', '', this.globalFilters.processorId);
    

    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.casesServicesService.all(params));
    this.caseServices = response.data;
    this.totalServicesRecords = response.meta['total'];
    this.loadingServices = false;
  }

  async loadFullInfo()
  {
    var params2 = "processor_all_casesId=" + ((!this.loginService.hasPermission('CASES.VIEW_ALL_CASES'))?this.user.id:"") + 
                  "&processorId=" + (this.globalFilters.processorId ?? this.user.id) + 
                  "&isFinal=false" +
                  "&revisionDateFrom=" + moment().startOf('day').toDate().toISOString() +
                  "&revisionDateTo=" + moment().endOf('day').toDate().toISOString() + 
                  "&contract_responsibleUserId=" + this.user.id;
    //hemos seleccionado un tramitador
    if(this.globalFilters.processorId) {params2 += "&filtered=true";}else{
      params2 += "&filtered=false";
    }

    let response = await firstValueFrom(this.dashboardService.getInfo(params2));
    //console.log(response);
    this.totalServicesWorkInProgressRecords = response.totalServicesWorkInProgressRecords;
    this.totalServicesReviewOldRecords = response.totalServicesReviewOldRecords;
    this.totalServicesReviewTodayRecords = response.totalServicesReviewTodayRecords;
    this.totalServicesActiveRecords = response.totalServicesActiveRecords;
    this.totalServicesNoProcessorRecords = response.totalServicesNoProcessorRecords;
    this.totalServicesNoCompanyRecords = response.totalServicesNoCompanyRecords;
    this.totalServicesNoCasesServices = response.totalServicesNoCasesServices;
  }


  async loadInvoicesDueSoon(){

    //Obtenemos el id de transactionType de la factura
    let paramsTransactionType: IParamsCollection = {
      include: []      
    }
    //creamos filtros
    paramsTransactionType.filter = FilterBuilder.fromObject({ code: new Filter(FilterOperation.equals, 'code', '', 'company_outgoing_invoice') }).build();

    let responseType = await firstValueFrom(this.transactionsTypesService.all(paramsTransactionType));
    let transactionType = responseType.data[0];

    //Obtenemos el id del estado "pending" para filtrar por transactionStateId (columna indexada) en vez de por
    //transactionState.code (tabla unida): asi el COUNT del widget hace seek por IX_transactions_DueSoon en vez de escanear.
    let paramsState: IParamsCollection = { include: [] };
    paramsState.filter = FilterBuilder.fromObject({ code: new Filter(FilterOperation.equals, 'code', '', 'pending') }).build();
    let responseState = await firstValueFrom(this.transactionsStatesService.all(paramsState));
    let pendingState = responseState.data[0];


    let dateLimit = moment().add(5, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
    let params: IParamsCollection = {
      page: { number: 1, size: 1 },
    };

    let filters: any = {
      paymentDuedate: new Filter(FilterOperation.lessOrEqual, "paymentDuedate",'', dateLimit),
      transactionTypeId: new Filter(FilterOperation.equals, 'transactionTypeId', '', transactionType.id),
      //isPayed: new Filter(FilterOperation.equals, 'isPayed', '', false),
      transactionStateId: new Filter(FilterOperation.equals, 'transactionStateId', '', pendingState.id),
    };

    params.filter = FilterBuilder.fromObject(filters).build();
    
    let response = await firstValueFrom(this.transactionsService.all(params));
    this.totalInvoicesDueSoon = response.meta['total'];
  }

  /*async goToCases(){
    this.router.navigate(['cases?withoutCompany=true']);
  }*/

  async loadPendingTasks(){
    let today = moment({h:23, m:59, s:59, ms:0}).format('YYYY-MM-DD HH:mm:ss');
    let user = this.storage.get("user");
    let params: IParamsCollection = { page: { number: 1, size: 1 } }
    let filters: any = {
      userId: new Filter(FilterOperation.equals, "userId",'',user.id),
      isCompleted: new Filter(FilterOperation.equals, "isCompleted", '', false),
      date: new Filter(FilterOperation.lessOrEqual, 'date','', today)
    };
    params.filter = FilterBuilder.fromObject(filters).build();
    
    let response = await firstValueFrom(this.tasksService.all(params));
    this.totalTask = response.meta['total'];
  }

  async loadLogs($event: any){
    this.lastGridLogEvent = $event;    
    this.loadingLogs = true;  

    //RevisionRequired está denormalizado en cases_logs (se copia del tipo al crear el log): filtramos directamente
    //por revisionRequired en vez de por caseLogType.revisionRequired, que generaba un JOIN con case_logs_types e
    //impedía el uso del índice, provocando escaneos de cases_logs (~26 GB).
    let filters: any = {
      direction: new Filter(FilterOperation.equals, "direction", '', "In"),
      requireRevision: new Filter(FilterOperation.equals, "revisionRequired", '', true),
      completedAt: new Filter(FilterOperation.equals, 'completedAt', '', null, true)
    };

    if(this.caseLogsFilter.caseLogTypeId){
      filters.caseLogTypeId = new Filter(FilterOperation.equals, "caseLogTypeId", '', this.caseLogsFilter.caseLogTypeId);
    }
        
    if(this.caseLogsFilter.caseContractId){
      filters.caseContractId = new Filter(FilterOperation.equals, "case.contractId", '', this.caseLogsFilter.caseContractId);
    }

    if(this.caseLogsFilter.caseCompanyId){
      filters.caseCompanyId = new Filter(FilterOperation.equals, "case.companyId", '', this.caseLogsFilter.caseCompanyId);
    }else{
      //si no hay compañia no mandamos contrato
      delete filters.caseContractId
      this.caseLogsFilter.caseContractId = null;
    }
    

    //Si tengo permiso de ver todos, ve todos, si es el permiso de 
    if(!this.VIEW_ALL_CASES){
      
      if(this.VIEW_CONTRACTS_CASES){
        
        //o es mia, o es una ausencia o son responsable del contrato o no tiene tramitador pero está en mis contratos.
        filters['processorId'] = new OrFilter([
          new Filter(FilterOperation.equals, 'case.contract.responsibleUserId', '', this.user.id),
          new Filter(FilterOperation.equals, 'case.contract.secondResponsibleUserId', '', this.user.id), //o soy segundo responsable del contrato
          new Filter(FilterOperation.equals, 'case.processorId', '', this.user.id),
          new AndFilter([
            new Filter(FilterOperation.equals, 'case.processorId', '', null, true), 
            new Filter(FilterOperation.equals, 'case.contract.responsibleUserId', '', this.user.id)
          ]),
          new AndFilter([
            new Filter(FilterOperation.equals, 'case.processor.absence', '', true),
            new Filter(FilterOperation.any, 'case.contractId', '', (this.processorContractIds.length>0?this.processorContractIds:null))
          ])
        ]);
      }else{

        filters['processorId'] =new OrFilter([
          new Filter(FilterOperation.equals, 'case.processorId', '', this.user.id),
          new AndFilter([
            new Filter(FilterOperation.equals, 'case.processorId', '', null, true),  
            new Filter(FilterOperation.any, 'case.contractId', '',(this.processorContractIds.length>0?this.processorContractIds:null))
          ]), //esta en mis contratos pero no tiene tramitador.
          new AndFilter([
            new Filter(FilterOperation.equals, 'case.processor.absence', '', true),
            new Filter(FilterOperation.any, 'case.contractId', '', (this.processorContractIds.length>0?this.processorContractIds:null))
          ])
      ]);
      }
    }

    if(this.globalFilters.processorId) filters['processorId'] = new Filter(FilterOperation.equals, 'case.processorId', '', this.globalFilters.processorId);

    let params: IParamsCollection = {
      sort: ['-date'],
      include: ['createdByUser', 'caseLogType', 'case.contract', 'case.processor'],
      filter: FilterBuilder.fromObject(  filters).build(),
      page: { number: $event.first + 1, size: $event.rows },
      fields: {
        cases: 'id,caseNumber,processorId,contractId,contract,processorId,processor,caseDate',
      }
    }    
    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    let response = await firstValueFrom(this.casesLogsService.all(params));
    this.caseLogs = response.data;

    this.caseLogs.forEach((log:any) => log.completed = log.completedAt !== null);
    
    this.totalLogsRecords = response.meta['total'];
    this.loadingLogs = false;	  
  }

  async goToTasks(){
    this.router.navigate(['tasks/pending/true']);
  }

  async editCaseService(caseService: CaseService | null) {
    let ref = this.dialogService.open(CaseServiceDetailComponent, {
      closable: true,
      modal: true,
      header: 'Ficha de servicio',
      width: '80%',
      data: {        
        caseServiceId: caseService ? caseService.id : null,
        showLilnkCase: true
      }
    });

    ref.onClose.subscribe((data: any) => {
      //this.loadCase(this.case.id!);
    });
  }

  async openChat(service: CaseService) {
    let titleParts:string[] = [];
    if(service.case) titleParts.push(service.case.caseNumber);
    let datePipe = new DatePipe('es-ES');
    titleParts.push('Servicio ' + datePipe.transform(service.date, 'dd/MM/yyyy')!);
    if(service.worker) titleParts.push(service.worker.name);
    let title = titleParts.join(" - ");
    this.chatService.openChatCaseService(service, title);
  }

  
    async loadInitialState() {
      let params: IParamsCollection = {}
      let filters = {
        isInitial: new Filter(FilterOperation.equals, 'isInitial', '', true)
      }
      //creamos filtros
      params.filter = FilterBuilder.fromObject(filters).build();
  
      let response = await firstValueFrom(this.casesStatesService.all(params));
      if (response.data[0].id !== undefined) {
        this.caseStateId = response.data[0].id;
      }
    }

  //Resuelve una sola vez los ids de los estados iniciales a partir de sus códigos, para poder filtrar el
  //widget de "expedientes sin citar" por caseStateId (FK indexada -> usa IX_cases_05) en vez de por
  //caseState.code (obliga a unir cases_states y no aprovecha el índice).
  async loadInitialCaseStateIds() {
    let params: IParamsCollection = {
      fields: { caseStates: 'id,code' },
      filter: FilterBuilder.fromObject({
        code: new Filter(FilterOperation.any, 'code', '', ['TRAMITATION_PENDING', 'PRE_CASE_SERVICE', 'ASSIGNMENT_PENDING'])
      }).build()
    };
    let response = await firstValueFrom(this.casesStatesService.all(params));
    this.initialCaseStateIds = (response.data ?? []).map((s: any) => s.id);
  }

  async loadDataCasesIsInitial($event: any) {
    
    this.lastGridCasesIsInitial = $event;    

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
      include: ['client', 'processor', 'address', 'caseState', 'caseType', 'contract', 'caseTreatment', 'caseServiceTypes.serviceType'],
      fields: {
        cases: 'id,caseNumber,caseDate,revisionDate,lastActionDate,expertStatus,isRecapture,isVIP,isUrgent,caseTypeId,caseType,caseStateId,caseState,contractId,contract,clientId,client,addressId,address,caseTreatmentId,caseTreatment,processorId,processor,caseServiceTypes',
        caseStates: 'id,name,code,backgroundColor,foregroundColor',
        contracts: 'id,code,name',
        caseTypes: 'id,name',
        users: 'id,name,phone1,phone2,email',
        clients: 'id,name,phone1,phone2,email',
        addresses: 'id,addressLine1,zipCode,city,countryCode,fullAddress',
        caseTreatments: 'id,name',
        caseServiceTypes: 'id,caseId,serviceTypeId,serviceType',
        serviceTypes: 'id,name'
      }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //Filtramos por caseStateId (FK indexada) en vez de por caseState.code (que une cases_states y no usa el índice).
    //Resolvemos los ids de los estados iniciales una sola vez; si no se pudieran resolver, caemos al filtro por código.
    if (!this.initialCaseStateIds || this.initialCaseStateIds.length === 0) {
      await this.loadInitialCaseStateIds();
    }
    let filters : any = {
      processorId: new Filter(FilterOperation.equals, 'processorId', '', this.globalFilters.processorId)
    }
    if (this.initialCaseStateIds.length > 0) {
      filters.caseStateId = new Filter(FilterOperation.any, 'caseStateId', '', this.initialCaseStateIds);
    } else {
      filters.caseStateId = new Filter(FilterOperation.any, 'caseState.code', '', ['TRAMITATION_PENDING', 'PRE_CASE_SERVICE', 'ASSIGNMENT_PENDING']);
    }
    //TODO: este es el unico que no tengo claro si van a salir los expedientes que no tengan tramitador a todo el mundo. Parece que si por el tipo de filtro pero no estoy 100% segura.
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();
    let user = this.storage.get("user");

    //let response = await firstValueFrom(this.casesServices.getAll(user.id, params));
    let response = await firstValueFrom(this.casesServices.all(params));
    this.casesIsInitial = response.data;
    this.totalcasesIsInitial = response.meta["total"];
  }

  
    getTimeAgo(date: Date) {
      let today = new Date();
      if(typeof date == "string"){
        //esto es lo que me esta devolviendo la funcion getall en vez de la de all... no se porqué
        date = new Date(date);
      }
      let diff = today.getTime() - date.getTime();
      
      let days = Math.floor(diff / (1000 * 60 * 60 * 24));
      let diffHours = diff - days * (1000 * 60 * 60 * 24);
      let hours = Math.floor(diffHours / (1000 * 60 * 60));
      let message = "";
      if(days>0) message = days + " días";
      if(hours>0) message += (message!=""?" y ":"") + hours + " hours";
      return message;
    }
  
    edit(caseItem: Case) {
      if(Object.keys(caseItem).length > 0){
        this.router.navigate(['cases/' + caseItem.id]);
      }else{    
          let ref = this.dialogService.open(CasesDetailGeneralComponent, {
            closable: true,
            modal: true,
            header: 'Datos generales',
            width: '50%',
            data: {
              
            }
          });
          ref.onClose.subscribe((data: Case) => {
            if(data!=null){
              this.router.navigate(['cases/' + data.id]);
            }
          });      
      }
      
    }
  
    delete(caseItem: Case) {
      if (this.allowDeleteService) {
        this.confirmationService.confirm({
          message: "¿Está seguro que desea eliminar el expediente?",
          header: "Eliminar expediente",
          acceptLabel: "Aceptar",
          rejectLabel: "Cancelar",
          acceptButtonStyleClass: "p-button-danger",
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.casesServices.delete(caseItem.id).subscribe({
              next: (data: any) => {
                this.messageService.add({ closable: true, severity: 'success', detail: "Expediente eliminado correctamente" });
                this.loadDataCasesIsInitial(this.lastGridEvent);
              },
              error: (error: any) => {
                this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
              }
            });
          },
          reject: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    }

    async showResourceInfoFromLog(caseLog: CaseLog){
          
      //comprobamos si ya está abierto, si está abierto, lo cerramos. 
      if(this.resourceCaseLog[caseLog.resourceId]){
        this.resourceCaseLog[caseLog.resourceId] = null;
      }else{
        if(caseLog.resourceId != null && caseLog.resourceType != CaseLogResourceType.Chat){

          //Buscamos dependiendo del resourceType
          if(caseLog.resourceType == CaseLogResourceType.Mail){
            var message =  await firstValueFrom(this.mailMessageService.get(caseLog.resourceId, {include: ['mailAccount', 'recipients', 'attachments.file']}));
            let filters = {
              mailMessageId: new Filter(FilterOperation.equals, 'mailMessageId', '', caseLog.resourceId)
            }      
            let params: IParamsCollection = {
              filter: FilterBuilder.fromObject(filters).build()
            }
        
            let receipts = await firstValueFrom(this.mailMessageRecipientService.all(params));            
  
            this.resourceCaseLog[caseLog.resourceId] = {
                message: message, 
                stateDate: moment(message.stateDate).format("DD/MM/YYYY HH:mm"),
                receipts: receipts.data.filter(m => m.recipientType=='To').map(m => m.mailAddress).join(', ')};
                  
              //esablecemos html al iframe
              setTimeout(() => {
              var iframe: any = document.getElementById("mail-preview-iframe-"+caseLog.resourceId);
              var contentDocument: any = iframe?.contentDocument;
              if (contentDocument != null) {
                contentDocument.open();
                contentDocument.write(message.content);
                contentDocument.close();
              }
            });
          }else if(caseLog.resourceType == CaseLogResourceType.Call){
            if(this.allowRecordingAccess){
              //buscamos el cdr
              let filter = {
                guid: new Filter(FilterOperation.equals, 'guid', '', caseLog.resourceId)
              }
              let params: IParamsCollection = {
                filter: FilterBuilder.fromObject(filter).build()
              }
              let response =  await firstValueFrom(this.cdrService.all(params));
              let call:Cdr;
              if(response.data.length>0){
                call = response.data[0];
              }else{
                return;
              }
  
              //buscamos la grabacion
              let filterRecording = {
                UniqueId: new Filter(FilterOperation.equals, 'uniqueId', '', call.uniqueId)
              }
              let paramsRecording: IParamsCollection = {
                filter: FilterBuilder.fromObject(filterRecording).build()
              }
              let responseRecordings = await firstValueFrom(this.recordingService.all(paramsRecording));
              if(responseRecordings.data.length>0){
                let recording:Recording = responseRecordings.data[0];
                this.resourceCaseLog[caseLog.resourceId] = { call: call, recording: recording };
              }
            }
          }
        }
      }      
    }

    downloadFile(fileId: string) {
      this.filesService.download(fileId);
    }
    
    getMailBody(mailMessage:MailMessage){
      var doc = new DOMParser().parseFromString(mailMessage.content, 'text/html');
      return doc.body.innerHTML || "Sin contenido";
    }

    async getRecordingUrl(recording:Recording){
      return this.recordingService.getDownloadUrl(recording);
    }

    async caseLogCompleted(event: any,caseLog:CaseLog){        
        caseLog.completedAt = event.checked ? new Date() : null;
        caseLog.completedById = event.checked ? this.user.id:null;
        await this.casesLogsService.save(caseLog).subscribe({
          next: (data) => {
            this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Comunicación completada correctamente' });
            this.loadLogs(this.lastGridLogEvent);
          },
          error: (error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar la especialidad' });
          }
        });

    }

    getCompletedStatus(caseLog: any): boolean {
      return caseLog.completedAt != null;
    }

    getRevisionDateClass(date: string | Date): string {
      const today = new Date();
      const revisionDate = new Date(date);

      const isToday =
          revisionDate.getFullYear() === today.getFullYear() &&
          revisionDate.getMonth() === today.getMonth() &&
          revisionDate.getDate() === today.getDate();
    
        if (revisionDate < today && !isToday) {
          return 'text-danger';
        } else if (isToday) {
          return 'text-warning';
        } else {
          return '';
        }
      }
    
      getBudgetTransactionStatusColor(caseItem: Case): string | null {
        let color = null;
        if (caseItem.budgetsStatus=='has_pending_budgets') color = 'bg-red-500';
        else if (caseItem.budgetsStatus=='budgets_ok') color = 'bg-green-500';
        return color;
      }
    
    
      getInvoiceTransactionStatusColor(caseItem: Case): string | null {
        let color = null;
        if (caseItem.invoicesStatus=='has_pending_invoices') color = 'bg-red-500';
        else if (caseItem.invoicesStatus=='invoices_ok') color = 'bg-green-500';
        return color;
      }




      
        showPhoneOverlayPanel($event:any, phoneNumber:string|undefined, callerId:string|undefined, caseService:CaseService|undefined = undefined, caseid: string|undefined = undefined){
          //si no hay caseService, buscamos el siguiente que lo toca en la lista
          if(caseService == undefined){
            console.log("No case service especified, searching for next caseservice");
            //ordenamos por fecha
            let orderedCaseServices = this.caseServices.sort((a: CaseService, b: CaseService) => {
              return a.date.getTime() - b.date.getTime();
            });
            //buscamos el siguiente
            caseService = orderedCaseServices.find((service: CaseService) => {
              return service.date >= new Date();
            });
          }
      
          this.phoneOverlayPanelData.caseService = caseService;
          this.phoneOverlayPanelData.phoneNumber = phoneNumber;
          this.phoneOverlayPanelData.callerId = callerId;
          this.phoneOverlayPanelData.caseId = caseid;
          this.phoneOverlayPanel?.show($event);
        }
      
        
        
    openWhatsapp(caseId:string|null = null, phoneNumber:string, name:string|null){
      //abrimos dialogo de whatsapp
      let ref = this.dialogService.open(WhatsAppChatComponent, {
        closable: true,
        modal: true,
        header: 'Whatsapp ' + phoneNumber + (name ? ' - ' + name : ''),
        width: '800px',
        draggable: true,
        data: {
          caseId: caseId,
          phoneNumber: phoneNumber,
          name: name
        }
      });
      ref.onClose.subscribe((data: any) => {
        //nothing to do
      });
    }

    addComunication(comunicationType:string|null, email:string|null, phoneNumber:string|null, attachment: boolean = false) {
      let comunicationModel:any = this.phoneOverlayPanelData.caseId;
      comunicationModel.caseService = this.phoneOverlayPanelData.caseService;
      let ref = this.dialogService.open(ComunicationsComponent, {
        closable: true,
        modal: true,
        header: 'Enviar comunicación',
        width: '60%',
        draggable: true,
        data: {
          caseId: this.phoneOverlayPanelData.caseId,
          model: comunicationModel,
          comunicationType: comunicationType,
          email: email,
          phoneNumber: phoneNumber,
          templateDestination: 'Case',
          // attachments: (attachment ? this.filesIdsToSend: [])
        }
      });
  
      ref.onClose.subscribe((data: any) => {
        // this.loadLogs(this.lastGridLogEvent);
      });
    }

  sms(phoneNumber:string|undefined, caseId:string|null = null, caseServiceId:string|null = null){
    if(phoneNumber){
      this.addComunication('SMS', null, phoneNumber);
      this.phoneOverlayPanel?.hide();
    }
  }

  whatsapp(phoneNumber:string|undefined, caseId:string|null = null, callerId:string|null = null){
    if(phoneNumber){
      //this.addComunication('Whatsapp', null, phoneNumber);
      this.openWhatsapp(caseId, phoneNumber, callerId);
      this.phoneOverlayPanel?.hide();
    }
  }

  call(phoneNumber:string|undefined, callerId:string|null = null, caseId:string|null = null, caseServiceId:string|null = null){
      if(phoneNumber){
      this.phoneService.call(phoneNumber!, callerId, true, caseId, caseServiceId);
      this.phoneOverlayPanel?.hide();
      }
  }

  async loadCaseLogTypes(){
    //los genericos
    let filters = {
      //isGeneric: new Filter(FilterOperation.equals, 'isGeneric', "", true)
    };
    let params: IParamsCollection = {
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.caseLogTypeService.all(params));
    this.caseLogTypes = response.data;
  }

  async loadCompanies() {
    let response = await firstValueFrom(this.companiesService.all());
    this.companies = response.data;
  }

  async loadContracts(companyId: any) {


    let filters = {
      companyId: new Filter(FilterOperation.equals, 'companyId', "", companyId)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractsService.all(params));
    this.contracts = response.data;    
  }

  private getUniqueIdsFromRows<T>(rows: T[], selector: (row: T) => string | null | undefined): string[] {
    return Array.from(new Set(rows.map(selector).filter((id): id is string => !!id)));
  }

  private isAllVisibleIdsSelected(visibleIds: string[], selectedIds: any[]): boolean {
    if (visibleIds.length === 0) return false;
    return visibleIds.every(id => selectedIds.includes(id));
  }

  private toggleVisibleIdsSelection(visibleIds: string[], selectedIds: any[], checked: boolean): any[] {
    if (checked) {
      return Array.from(new Set([...(selectedIds || []), ...visibleIds]));
    }

    const visibleIdsSet = new Set(visibleIds);
    return (selectedIds || []).filter(id => !visibleIdsSet.has(id));
  }

  private getCurrentCaseServiceIds(): string[] {
    return this.getUniqueIdsFromRows(this.caseServices, service => service.caseId);
  }

  private getCurrentCaseLogIds(): string[] {
    return this.getUniqueIdsFromRows(this.caseLogs, log => log.case?.id);
  }

  isAllCaseServicesSelected(): boolean {
    return this.isAllVisibleIdsSelected(this.getCurrentCaseServiceIds(), this.selectedCases);
  }

  toggleAllCaseServicesSelection(checked: boolean): void {
    this.selectedCases = this.toggleVisibleIdsSelection(this.getCurrentCaseServiceIds(), this.selectedCases, checked);
  }

  isAllCaseLogsSelected(): boolean {
    return this.isAllVisibleIdsSelected(this.getCurrentCaseLogIds(), this.selectedCases1);
  }

  toggleAllCaseLogsSelection(checked: boolean): void {
    this.selectedCases1 = this.toggleVisibleIdsSelection(this.getCurrentCaseLogIds(), this.selectedCases1, checked);
  }

  assignProcessor(type: number) {
    if(type == 0) this.selectedCaseIds = Array.from(new Set(this.selectedCases.filter(m => m != null)));
    if(type == 1) this.selectedCaseIds = Array.from(new Set(this.selectedCases1.filter(m => m != null)));
    if(type == 2) this.selectedCaseIds = this.selectedCases2.map(m => m.id);

    if (this.selectedCaseIds.length > 0) {
      this.loadProcessors();
      this.displayProcessorModal = true;
    } else {
      this.messageService.add({ closable: true, severity: 'error', detail: "Debe seleccionar al menos un expediente" });
    }
  }

  async saveProcessor() {
    await firstValueFrom(this.casesServices.updateProcessor(this.processorId!, this.selectedCaseIds));
    this.displayProcessorModal = false;
    this.selectedCases = [];
    this.selectedCases1 = [];
    this.selectedCases2 = [];
    this.selectedCaseIds = [];
    //recargamos los tres porque pueden concidir en expediente en las tres tablas
    this.loadServices(this.lastGridEvent);
    this.loadLogs(this.lastGridLogEvent);
    this.loadDataCasesIsInitial(this.lastGridCasesIsInitial);
  }

  
  private scrollToFragment(fragment: string, retries: number = 12) {
    const element = document.getElementById(fragment);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    if (retries > 0) {
      setTimeout(() => this.scrollToFragment(fragment, retries - 1), 150);
    }
  }
  private waitingForLoadingElements(fragment: string){
    console.log("Waiting for loading elements to scroll to fragment: ", fragment,this.loadingLogs,this.loadingServices);
    if(this.loadingLogs || this.loadingServices){
      setTimeout(() => this.waitingForLoadingElements(fragment), 150);
      return;
    }
    setTimeout(() => this.scrollToFragment(fragment), 150);
    
  }

}
